import React from 'react';
import WeeklyDescription from "./weekly-description.jsx";

const WeeklyTable = ({firstType, weekColumns, data}) => {
    return (
        <div className={firstType === "WEEKLY_VIEW" ? "" : "hidden!"}>
            <table id="displacement-weekly-data" className={`table report-table`} sheet-name="Ocorrências por naturezas">
                <thead className="thead-background print:table-row-group!">
                <tr className="bg-[#f6f6f6] text-left">
                    <th className={"w-[15%]!"}>Natureza</th>
                    {weekColumns.map(c => {
                        return (<th className="text-center text-[13px]">{c.title}</th>)
                    })}
                    <th className="text-center bg-[#f6f6f6]!">Total</th>
                    <th className="text-center bg-[#f6f6f6]!">Média</th>
                    <th className="text-center text-[13px] cursor-pointer" title="Diferença absoluta dos últimos 15 dias">Dif. 15d</th>
                    <th className="text-center text-[13px] cursor-pointer" title="Diferença percentual dos últimos 15 dias">Dif. % 15d</th>
                </tr>
                </thead>
                <tbody className="bg-white">

                {data.weeklyData.map((element, rowIndex) => {
                    const diffClassName = element.diff_15 > 0  ? "text-[#a8231b] font-bold italic" : element.diff_15 < 0 ? "text-[#25c469] font-bold italic" : "text-black";
                    const percClassName = element.percent_diff_15 > 0 ? "text-[#a8231b] font-bold italic" : element.percent_diff_15 < 0 ? "text-[#25c469] font-bold italic" : "text-black";

                    return (
                        <tr key={`row-${rowIndex}`}>
                            <td className={"w-[15%]!"}>{element.natures}</td>
                            {weekColumns.map(c => {
                                return (<td className="text-center">{element[c.field] ?? 0}</td>)
                            })}
                            <td className="text-center bg-[#f6f6f6]!">{element.total}</td>
                            <td className="text-center bg-[#f6f6f6]!">{element.media}</td>
                            <td className={`text-center ${diffClassName}`}><b>{element.diff_15 > 0 ? '+' : ''}{element.diff_15}</b></td>
                            <td className={`text-center ${percClassName}`}><b>{element.percent_diff_15 > 0 ? '+' : ''} {element.percent_diff_15}%</b></td>
                        </tr>
                    )
                })}
                </tbody>
            </table>

            <WeeklyDescription />
        </div>
    );
};

export default WeeklyTable;
